export const LOGIN = '/login'
